export const LOGIN = '/login'
